import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-d5d14a0c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "bookDemo-page"
};
const _hoisted_2 = {
  class: "content-box"
};
const _hoisted_3 = {
  class: "content"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "title"
}, "预约演示", -1));
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tips"
}, " 想了解更多云起无垠的产品信息？请提交您的信息，我们的安全专家会与您取得联系！ ", -1));
const _hoisted_7 = {
  class: "from-box"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "自用"
}, "自用", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "科研"
}, "科研", -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "其他"
}, "其他", -1));
const _hoisted_11 = [_hoisted_8, _hoisted_9, _hoisted_10];
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "安全知识类智能体"
}, " 安全知识类智能体 ", -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "代码安全类智能体"
}, " 代码安全类智能体 ", -1));
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "无垠模糊测试智能体"
}, " 无垠模糊测试智能体 ", -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "无瑕软件缺陷分析智能体"
}, " 无瑕软件缺陷分析智能体 ", -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "模型定制化训练框架"
}, " 模型定制化训练框架 ", -1));
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "安全服务"
}, " 安全服务 ", -1));
const _hoisted_18 = [_hoisted_12, _hoisted_13, _hoisted_14, _hoisted_15, _hoisted_16, _hoisted_17];
const _hoisted_19 = {
  class: "box",
  style: {}
};
const _hoisted_20 = {
  class: "footer-box"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h5", {
  class: "title"
}, "问题答疑", -1));
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tips"
}, " 如有任何疑问，欢迎扫描下方微信二维码添加客服小云 ", -1));
const _hoisted_23 = {
  class: "RQcode",
  alt: "客服小云"
};
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "contact"
}, "咨询服务热线：010-58171400", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_header_com = _resolveComponent("header-com");
  const _component_a_input = _resolveComponent("a-input");
  const _component_a_form_item = _resolveComponent("a-form-item");
  const _component_a_col = _resolveComponent("a-col");
  const _component_buttom_com = _resolveComponent("buttom-com");
  const _component_a_row = _resolveComponent("a-row");
  const _component_a_form = _resolveComponent("a-form");
  const _component_success_com = _resolveComponent("success-com");
  const _component_footer_com = _resolveComponent("footer-com");
  const _directive_lazy = _resolveDirective("lazy");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [!_ctx.isMobile ? (_openBlock(), _createBlock(_component_header_com, {
    key: 0,
    headerType: "demo"
  })) : _createCommentVNode("", true), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [_hoisted_4, !_ctx.isSuccess ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, [_createVNode(_component_a_form, {
    class: "from",
    model: _ctx.formState,
    name: "basic",
    "label-col": {
      span: 24
    },
    "wrapper-col": {
      span: 24
    },
    autocomplete: "off",
    ref: "fromDOM"
  }, {
    default: _withCtx(() => [_createVNode(_component_a_row, {
      gutter: {
        md: 24,
        sm: 16
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_a_col, {
        md: 12,
        sm: 24
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form_item, {
          label: "您的姓名",
          name: "username",
          colon: false,
          "label-col": {
            span: 24
          },
          "wrapper-col": {
            span: 24
          },
          rules: [{
            required: true,
            message: '请填写您的姓名!'
          }]
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            autocomplete: "off",
            maxlength: 10,
            value: _ctx.formState.username,
            "onUpdate:value": _cache[0] || (_cache[0] = $event => _ctx.formState.username = $event)
          }, null, 8, ["value"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_a_col, {
        md: 12,
        sm: 24
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form_item, {
          label: "联系电话",
          name: "contactPhone",
          colon: false,
          "label-col": {
            span: 24
          },
          "wrapper-col": {
            span: 24
          },
          rules: [{
            required: true,
            message: '请填写联系电话!'
          }]
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            autocomplete: "off",
            maxlength: 13,
            value: _ctx.formState.contactPhone,
            "onUpdate:value": _cache[1] || (_cache[1] = $event => _ctx.formState.contactPhone = $event)
          }, null, 8, ["value"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_a_col, {
        md: 12,
        sm: 24
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form_item, {
          label: "合作意向",
          name: "contactMail",
          colon: false,
          "label-col": {
            span: 24
          },
          "wrapper-col": {
            span: 24
          },
          rules: [{
            required: true,
            message: '请选择合作意向!'
          }]
        }, {
          default: _withCtx(() => [_createElementVNode("select", {
            class: "select-box",
            onChange: _cache[2] || (_cache[2] = (...args) => _ctx.selectChange1 && _ctx.selectChange1(...args))
          }, _hoisted_11, 32)]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_a_col, {
        md: 12,
        sm: 24
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form_item, {
          label: "咨询产品",
          name: "inquiryProduct",
          colon: false,
          "label-col": {
            span: 24
          },
          "wrapper-col": {
            span: 24
          }
        }, {
          default: _withCtx(() => [_createElementVNode("select", {
            class: "select-box",
            onChange: _cache[3] || (_cache[3] = (...args) => _ctx.selectChange && _ctx.selectChange(...args))
          }, _hoisted_18, 32)]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_a_col, {
        span: 24
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form_item, {
          class: "button-box"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_19, [_createVNode(_component_buttom_com, {
            btnName: "预约演示",
            onClick: _ctx.saveData,
            filling: true
          }, null, 8, ["onClick"])])]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  }, 8, ["model"])])])) : (_openBlock(), _createBlock(_component_success_com, {
    key: 1,
    type: "class2"
  })), _createElementVNode("div", _hoisted_20, [_hoisted_21, _hoisted_22, _withDirectives(_createElementVNode("img", _hoisted_23, null, 512), [[_directive_lazy, require('@/assets/img/customerService.png')]]), _hoisted_24])])), [[_directive_lazy, require('@/assets/img/bookDemo/content-bg.png'), "background-image"]])])), [[_directive_lazy, require('@/assets/img/bookDemo/bookDemo-bg.png'), "background-image"]]), !_ctx.isMobile ? (_openBlock(), _createBlock(_component_footer_com, {
    key: 1
  })) : _createCommentVNode("", true)]);
}